export default () => ({
    list: [],
    listError: null,
    listLoading: false,
})